import React from 'react';
import { withRouter } from 'react-router-dom';
import {
    Box
} from '@material-ui/core';
import 'react-tippy/dist/tippy.css';

class WorkshopLayoutComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    styles = {
        minHeight: "80vh",
        ...(this.props.excludeMargin ? {} : { margin: "3rem 6rem" }),
    }

    render() {
        return (
            <React.Fragment>
                <Box sx={this.styles}>
                    {this.props.children}
                </Box>
            </React.Fragment>
        );
    }
}

export default withRouter(WorkshopLayoutComponent);
